module.exports = __webpack_public_path__ + "static/media/sura-muti-parking-selected.dc942751.svg";